export default __webpack_public_path__ + "static/media/ic_bermuda.985b08cc.svg";